function getRootCssPropertyValue(cssVarName) {
  return window.getComputedStyle(document.documentElement).getPropertyValue(cssVarName);
}
export {getRootCssPropertyValue};
